/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { candidateSchema } from './candidate-schema';
import { opportunitySchema } from './opportunity-schema';

export const candidatesSavedOpportunitySchema: z.AnyZodObject = z.object({
  candidate: z.lazy(() => candidateSchema).nullish(),
  candidateId: z.string().uuid().nullish(),
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  opportunity: z.lazy(() => opportunitySchema).nullish(),
  opportunityId: z.string().uuid().nullish(),
  updatedAt: z.string().datetime().nullish(),
});

export type CandidatesSavedOpportunity = z.infer<typeof candidatesSavedOpportunitySchema>;
